import { StockPlan } from 'types';

export const getPlanFutureShares = (plans: StockPlan[]) => {
  if (!plans) {
    return 0;
  }

  return plans.reduce((totalShares, plan) => {
    if (plan?.isDraft) {
      return totalShares;
    }
    return totalShares + (plan?.sharesTotal || 0);
  }, 0);
};
